import { Helmet } from "react-helmet-async";

export const Seo = ({ title, description, canonical, jsonLd }) => (
    <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        {canonical && <link rel="canonical" href={canonical} />}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonical} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        {jsonLd && (
            <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
        )}
    </Helmet>
);
